// components/ReservationHeader.jsx
import React from "react";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import AsyncSelect from "../../AsyncSelect";
import CardStatus from "./CardStatus";
import styles from "../ModalDetailReservationV2.module.css";

const ReservationHeader = ({
  dataDetailReservation = {},
  selectedLocation = null,
  dataLocations = [],
  handleChangeForm = () => undefined,
  isReservation = false,
}) => {
  const localize = useLocalization();

  return (
    <div className={styles.reservationHeader}>
      <div className={styles.reservationInfo}>
        <div className={styles.reservationInfoItem}>
          <i className={`far fa-calendar-alt ${styles.reservationInfoIcon}`} />
          <p className={styles.reservationInfoText}>
            {dataDetailReservation.reservationDate &&
            dataDetailReservation.reservationTime
              ? `${dataDetailReservation.reservationDate}, ${dataDetailReservation.reservationTime}`
              : "-"}
          </p>
        </div>
        <div className={styles.reservationInfoItem}>
          <i className={`fas fa-stethoscope ${styles.reservationInfoIcon}`} />
          <p className={styles.reservationInfoText}>
            Dokter {dataDetailReservation.doctorName}
          </p>
        </div>
      </div>
      <div className={styles.reservationActions}>
        <CardStatus
          label={`${dataDetailReservation.durationVisit} menit
`}
        />
        {isReservation || !dataDetailReservation.patientId ? (
          <AsyncSelect
            options={dataLocations}
            placeholder={localize.getText("placeholderField", {
              fieldName: localize.getText("location"),
            })}
            onChange={(value) => handleChangeForm("locationId", value)}
            value={selectedLocation}
            labelKey="name"
            valueKey="id"
            disabled={!isReservation}
            size="small"
          />
        ) : (
          <div className={styles.roomInfo}>
            <i className={`far fa-hospital ${styles.roomIcon}`} />
            <p className={styles.roomText}>
              Ruangan {selectedLocation?.label || "-"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReservationHeader;
